<template>
  <div class="footer flex-col">
    <div class="footer-content flex-row">
      <div class="footer-left flex-row">
        <div class="footer-title flex-col">
          <p @click="jump('关于我们', '/aboutus')">关于我们</p>
          <p @click="jump('关于我们', '/aboutus', '#introduce')">公司介绍</p>
          <p @click="jump('关于我们', '/aboutus', '#creator')">创始人寄语</p>
          <p @click="jump('关于我们', '/aboutus', '#organization')">组织架构</p>
          <p @click="jump('关于我们', '/aboutus', '#develop')">发展历程</p>
          <p @click="jump('关于我们', '/aboutus', '#evaluate')">各界评价</p>
          <!-- <p @click="jump('关于我们', '/aboutus', '#cooperation')">合作伙伴</p> -->
        </div>
        <div class="footer-title flex-col">
          <p style="cursor: auto">业务生态</p>
          <p @click="jump('业务生态', '/capital')">产业投资</p>
          <p @click="jump('业务生态', '/invest')">产业精准招商</p>
          <p @click="jump('业务生态', '/plan')">产业赋能服务</p>
          <p @click="jump('业务生态', '/analysis')">产业数据分析</p>
          <p @click="jump('业务生态', '/train')">产业人才培训</p>
          <!-- <p @click="jump('业务生态', '/layout')">产业项目布局</p> -->
        </div>
        <div class="footer-title flex-col">
          <p @click="jump('全流程服务', '/service')">全流程服务</p>
          <p @click="jump('全流程服务', '/service', '#progress')">合作流程</p>
          <p @click="jump('全流程服务', '/service', '#service-case')">
            落地案例
          </p>
          <p @click="jump('全流程服务', '/service', '#service-activity')">
            重磅活动
          </p>
        </div>
        <div class="footer-title flex-col">
          <p @click="jump('中产资讯', '/news')">中产资讯</p>
          <p @click="jump('中产资讯', '/news', false, '新闻动态')">新闻动态</p>
          <p @click="jump('中产资讯', '/news', false, '项目预告')">项目预告</p>
          <p @click="jump('中产资讯', '/news', false, '产业观察')">产业观察</p>
          <p @click="jump('中产资讯', '/news', false, '专题策划')">专题策划</p>
        </div>
        <div class="footer-title flex-col">
          <p @click="jump('联系我们', '/contactUs', '#contact')">联系我们</p>
          <!-- <p>项目</p>
                    <p>政府</p>
                    <p>培训</p>
                    <p>加入我们</p> -->
        </div>
      </div>
      <div class="footer-right flex-row">
        <div class="flex-col">
          <div class="flex-row">
            <div
              class="icon flex-row"
              @mouseleave="current = ''"
              @mouseover="current = 'wx'"
            >
              <img
                v-if="current == 'wx'"
                style="position: absolute; top: -260px; left: -60px"
                src="@/assets/images/contactUs/zc-qrcode.png"
                alt=""
              />
              <img
                :src="
                  current == 'wx'
                    ? require('@/assets/images/common/wx-active.png')
                    : require('@/assets/images/common/wx.png')
                "
                alt=""
              />
            </div>
            <div
              class="icon flex-row"
              @mouseleave="current = ''"
              @mouseover="current = 'wb'"
            >
              <img
                v-if="current == 'wb'"
                style="position: absolute; top: -180px; left: -60px"
                src="@/assets/images/common/arcode-wb.png"
                alt=""
              />
              <img
                :src="
                  current == 'wb'
                    ? require('@/assets/images/common/wb-active.png')
                    : require('@/assets/images/common/wb.png')
                "
                alt=""
              />
            </div>
            <div
              class="icon flex-row"
              @mouseleave="current = ''"
              @mouseover="current = 'dy'"
            >
              <img
                v-if="current == 'dy'"
                style="position: absolute; top: -180px; left: -60px"
                src="@/assets/images/common/arcode-dy.png"
                alt=""
              />
              <img
                :src="
                  current == 'dy'
                    ? require('@/assets/images/common/dy-active.png')
                    : require('@/assets/images/common/dy.png')
                "
                alt=""
              />
            </div>
          </div>
          <p style="text-align: center">扫码关注中产集团</p>
        </div>
        <div class="flex-col" style="margin-left: 30px">
          <div
            @click="jump('联系我们', '/contactus', '#contact')"
            class="online-service flex-row"
          >
            <img src="@/assets/images/common/call.png" alt="" />在线客服
          </div>
          <div style="font-size: 20px">
            <img
              style="vertical-align: middle; margin-right: 10px"
              src="@/assets/images/common/phone.png"
              alt=""
            />服务热线
          </div>
          <div style="font-size: 36px; margin: 5px auto">400-820-3779</div>
          <p>周一至周五 9:00～18:00</p>
        </div>
      </div>
    </div>
    <div class="footer-line"></div>
    <div class="copyright">
      中产集团 版权所有 Copyright @ 2014-{{
        new Date().getFullYear()
      }}
      Chinaindustria Corporation, All Rights Reseved.&emsp;<a
        style="color: #999"
        href="https://beian.miit.gov.cn/#/Integrated/recordQuery"
        >沪ICP备2020032230号</a
      >&emsp;<a
        style="color: #999"
        href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31011502016374"
        ><img src="@/assets/images/common/gongan.png" alt="" />
        沪公网安备31011502016374号</a
      >
    </div>
  </div>
</template>

<script>
import "@/assets/css/footer.css";
export default {
  name: "Footer",
  data() {
    return {
      headCurrent: "",
      current: "",
    };
  },
  watch: {
    current(n, o) {
      switch (n) {
        case "wx":
          break;
        case "wb":
          break;
        case "dy":
          break;
        default:
          break;
      }
    },
  },
  methods: {
    jump(name, path, aName, param) {
      //aName锚点,param资讯类别
      this.headCurrent = name;
      sessionStorage.setItem("headCurrent", name);
      if (location.pathname.indexOf(path) != -1 && aName) {
        document
          .getElementById(aName.replace(/#/, ""))
          .scrollIntoView({ block: "start" });
      } else {
        this.$router.push({ path: param ? path + "?" + param : path });
        this.backTop();
        if (aName) {
          setTimeout(() => {
            document
              .getElementById(aName.replace(/#/, ""))
              .scrollIntoView({ behavior: "smooth", block: "start" });
          }, 300);
        }
      }
    },
    backTop() {
      document.documentElement.scrollTop = 0;
      // var a = document.createElement('a');
      // a.setAttribute('href', aName);
      // a.setAttribute('target', '_self');
      // a.setAttribute('id', aName);
      // // 防止反复添加
      // if (document.getElementById(aName)) {
      // document.body.removeChild(document.getElementById(aName));
      // }
      // document.body.appendChild(a);
      // a.click();

      //滚动动画
      // var timer = setInterval(function() {
      //   let osTop =
      //     document.documentElement.scrollTop || document.body.scrollTop;
      //   let ispeed = Math.floor(-osTop / 3);
      //   document.documentElement.scrollTop = document.body.scrollTop =
      //     osTop + ispeed;
      //   this.isTop = true;
      //   if (osTop == 0) {
      //     clearInterval(timer);
      //   }
      // }, 10);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Footer.vue